export const useEnterPressable = (onPress: () => void) => {
  const onEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "ENTER") {
      onPress();
    }
  };
  return onEnterPress;
};
